import { Select, Radio, Space } from 'antd';
import { v4 as uuid } from 'uuid';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { BUTTON_VARIANT_DARK } from '../../../../../../../components/forms/ZorbaButton/constants';
import { ZorbaButton } from '../../../../../../../components/forms';
import { setAppliedFilters } from '../../../../../../../reducers/Offer/actions';

import { options } from '../constants';

import '../index.scss';

export const CountyBuilder = ({ onApplyFilter }) => {
  const dispatch = useDispatch();
  const { appliedFilters, counties } = useSelector(
    ({ OfferReducer }) => OfferReducer,
  );
  const [defaultRadioValue] = Object.keys(appliedFilters.county ?? {});
  const defaultSelectValue = defaultRadioValue
    ? appliedFilters.county[defaultRadioValue]
    : [];

  const [radioValue, setRadioValue] = useState(defaultRadioValue);
  const [selectedCounties, setSelectedCounties] = useState(defaultSelectValue);
  const statusOptions = counties.map((market) => ({
    label: market,
    value: market,
  }));
  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleSelectChange = (newValue) => {
    setSelectedCounties(newValue);
  };

  const isApplyButtonDisabled = !radioValue || !selectedCounties.length;
  const handleApply = () => {
    dispatch(
      setAppliedFilters('county', {
        [radioValue]: selectedCounties,
      }),
    );
    onApplyFilter();
  };

  return (
    <div className="builder-container">
      <h3>County</h3>
      <div className="options-container">
        <Radio.Group onChange={handleRadioChange} value={radioValue}>
          <Space direction="vertical">
            {options.map((option) => (
              <Radio key={uuid()} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {radioValue && (
          <Select
            mode="tags"
            className="select"
            placeholder="Select County"
            onChange={(newValue) => handleSelectChange(newValue)}
            value={selectedCounties}
            options={statusOptions}
          />
        )}
      </div>
      <ZorbaButton
        variant={BUTTON_VARIANT_DARK}
        disabled={isApplyButtonDisabled}
        onClick={handleApply}
        fullWidth={false}
      >
        Apply
      </ZorbaButton>
    </div>
  );
};
